"use strict";

var mainContentType = "application/vnd.openxmlformats-officedocument.wordprocessingml.document.main+xml";
var headerContentType = "application/vnd.openxmlformats-officedocument.wordprocessingml.header+xml";
var footerContentType = "application/vnd.openxmlformats-officedocument.wordprocessingml.footer+xml";
var slideContentType = "application/vnd.openxmlformats-officedocument.presentationml.slide+xml";
var mainWithMacroContentType = "application/vnd.ms-word.document.macroEnabled.main+xml";
var mainTemplateContentType = "application/vnd.openxmlformats-officedocument.wordprocessingml.template.main+xml";
var mainTemplateWithMacroContentType = "application/vnd.ms-word.template.macroEnabledTemplate.main+xml";
var commentContentType = "application/vnd.openxmlformats-officedocument.wordprocessingml.comments+xml";
var drawingContentType = "application/vnd.openxmlformats-officedocument.drawing+xml";
var xlsxContentType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml";
var xlsmContentType = "application/vnd.ms-excel.sheet.macroEnabled.main+xml";
var xlsxWorksheetContentType = "application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml";
var sheetContentType = "application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml";
module.exports = {
  drawingContentType: drawingContentType,
  commentContentType: commentContentType,
  mainContentType: mainContentType,
  xlsxContentType: xlsxContentType,
  xlsmContentType: xlsmContentType,
  xlsxWorksheetContentType: xlsxWorksheetContentType,
  sheetContentType: sheetContentType,
  headerContentType: headerContentType,
  footerContentType: footerContentType,
  slideContentType: slideContentType,
  mainWithMacroContentType: mainWithMacroContentType,
  mainTemplateContentType: mainTemplateContentType,
  mainTemplateWithMacroContentType: mainTemplateWithMacroContentType,
  main: [mainContentType, mainWithMacroContentType, mainTemplateContentType, mainTemplateWithMacroContentType]
};